import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

const AccommodationPackageTileContentGrid = styled.div`
  display: grid;
  gap: ${rem(12)} ${rem(32)};
  grid-template-columns: 1fr;
  grid-auto-rows: min-content;

  ${mediaQueryUp.tablet} {
    gap: ${rem(12)} ${rem(16)};
  }

  ${mediaQueryUp.desktop} {
    gap: ${rem(12)} ${rem(32)};
    grid-template-columns: ${rem(238)} 1fr;
  }
`
export function AccommodationPackageTileContent(props: PropsWithChildren) {
  return <AccommodationPackageTileContentGrid {...props} />
}

const AccommodationPackageTilePricingGroup = styled(Group)``
export function AccommodationPackageTilePricing(props: PropsWithChildren) {
  return <AccommodationPackageTilePricingGroup
    {...props}
    direction="vertical"
    gap={12}
  />
}

const AccommodationPackageTileGrid = styled.div`
  padding: ${rem(20)};
  display: grid;
  gap: ${rem(12)} ${rem(32)};
  grid-template:
    "content"
    "pricing" auto / 1fr;

  ${mediaQueryUp.tablet} {
    grid-template:
      "content pricing" auto / minmax(0, 1fr) ${rem(364)};
  }

  ${mediaQueryUp.desktop} {
    grid-template: "content pricing" auto / minmax(0, 1fr) ${rem(380)};
  }

  > ${AccommodationPackageTileContentGrid} {
    grid-area: content;
  }
  > ${AccommodationPackageTilePricingGroup} {
    grid-area: pricing;
  }
`

function AccommodationPackageTile(props: PropsWithChildren) {
  return <AccommodationPackageTileGrid {...props} />
}

export default AccommodationPackageTile
